import { Action } from '@ngrx/store';

export function deleteSuccessType<TModel>(module: string, type: { new(): TModel; }): string {
  return `[${module}] Delete ${(type as any).$typeName} Success`;
}

export class DeleteSuccessAction<TModel> implements Action {
  readonly type: string;

  constructor(module: string, modelType: { new(): TModel; }, public payload: { key: string }) {
    this.type = deleteSuccessType(module, modelType);
  }
}




// WEBPACK FOOTER //
// ./src/app/pillar/dashboard/store/actions/DeleteSuccessAction.ts